export default __webpack_public_path__ + "static/media/Udyog-Aadhaar-Registration.fd23ca66.png";